module.exports = __webpack_public_path__ + "img/English.5629c5eb.svg";